import "./SalesBanner.css";
import { useHistory } from "react-router-dom";
import CountDownTimer from "./CountDownTimer";
import images from "../../../../utilities/images/images";
import { navigateFromUserDashboardBanner } from "../../../../custom_utilities/dashboardBannerNavigation";

const SalesBanner = ({ data }) => {
  const {
    text,
    remaining_secs,
    button_text,
    bottom_text1,
    bottom_text2,
    web_banner_image_url,
    web_logo,
    title,
  } = data;

  const history = useHistory();

  return (
    // <div style={{ width: "100%", position: "relative" }}>
    <div className="sales-banner-wrapper">
      <div className="sales-banner-image">
      <img
        src={web_banner_image_url}
        // style={{
        //   width: "1550px",
        //   height: "400px",
        // }}
      />
      </div>

      <div className="sales-inner-wrapper">
        <div className="sales-descript">
          <img src={web_logo} />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <div className="sales-text">{text} </div>
          <div onClick={() => navigateFromUserDashboardBanner(history, "/store")}>
            <img
              src={images.sales_right_arrow}
              alt="arrow-button"
              style={{
                marginLeft: "0.5rem",
                width: "1.5rem",
                height: "1.5rem",
                cursor: "pointer",
              }}
            />
          </div>
        </div>
        <CountDownTimer initialSeconds={remaining_secs} />
        <div
          className="sales-button-text"
          onClick={() => navigateFromUserDashboardBanner(history, "/store")}
        >
          {button_text}
        </div>
        <div className="sales-bottom-text-container">
          <div className="sales-bottom-text1">{bottom_text1}</div>
          <div className="sales-bottom-text2">{bottom_text2}</div>
        </div>
      </div>
    </div>
  );
};

export default SalesBanner;
